import {
  ILink,
  IField,
  IFormDocument,
} from 'app/services/api5-service/api.interface';
import { getLinkUi } from 'components/link/link.utils';
import { LinkUi } from 'components/link/model';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { LinkProps } from './model/link-props.interface';

import {
  ISPFieldConfig,
  ISPFieldType,
  ISPFieldWrapper,
  ISPFormState,
} from '../../model';
import { getImage } from '../../utils/get-image';

/**
 * Get data for link
 *
 * @param control - control (subfield) metadata
 * @param field - field metadata
 * @param doc
 */
function getLinkData(
  control: ILink,
  field: IField,
  doc: IFormDocument,
): LinkUi {
  return {
    img: getImage(field, doc),
    ...getLinkUi(control, doc),
  };
}

/**
 * Get stream of link data
 *
 * @param control
 * @param field
 * @param state
 */
function getLinkData$(
  control: ILink,
  field: IField,
  state: ISPFormState,
): Observable<LinkUi> {
  return state.docSubject.pipe(map(doc => getLinkData(control, field, doc)));
}

/**
 * Get props for link field
 *
 * @param control - control (subfield) metadata
 * @param field - field metadata
 * @param state - dynamic form state
 */
export function getLinkProps(
  control: ILink,
  field: IField,
  state: ISPFormState,
): LinkProps {
  return {
    originalControl: control,
    originalField: field,
    data$: getLinkData$(control, field, state),
  };
}

/**
 * Get config for link field
 *
 * @param control - control (subfield) metadata
 * @param field - field metadata
 * @param state - dynamic form state
 */
export function getLinkConfig(
  control: ILink,
  field: IField,
  state: ISPFormState,
): ISPFieldConfig<ISPFieldType.Link> {
  const props = getLinkProps(control, field, state);

  return {
    type: ISPFieldType.Link,
    wrappers: [ISPFieldWrapper.FieldBase],
    props,
  };
}
